export default "__VITE_ASSET__CSvk1DBb__"